<div class="search-results-tab-container own-scroll">
  <nb-list
    *ngIf="firstCard.news.length > 0"
    nbInfiniteList
    [threshold]="440"
    (bottomThreshold)="loadNext(firstCard)"
    (scroll)="onScroll($event)"
    class="search-result-list"
  >
    <nb-list-item
      *ngFor="let result of firstCard.news; let i = index"
      (click)="navigateToSubscribers(result, data.type)"
    >
      <nb-icon nbPrefix icon="archive-outline" pack="eva"></nb-icon>
      <span class="label">{{ 'SUBSCRIPTION.HRI' | translate }}:</span>
      {{ result.hri }}
      <span class="label">{{ 'SUBSCRIPTION.PUBLISHER' | translate }}:</span>
      {{ result.publisher?.name }}
      <span class="label">{{ 'SUBSCRIPTION.TYPE' | translate }}:</span>
      {{ result.type?.name }}
      <span class="label">{{ 'SUBSCRIPTION.OWNER' | translate }}:</span>
      <span class="no-search-results">{{
        result.owner ? result.owner['lastName'] : ('GLOBAL_SEARCH.NO_RESULT' | translate)
      }}</span>
    </nb-list-item>
    <nb-list-item *ngFor="let _ of firstCard.placeholders">
      <p>Loading ...</p>
    </nb-list-item>
  </nb-list>
  <div *ngIf="data.results.length === 0" class="no-search-results">
    {{ 'GLOBAL_SEARCH.NO_SEARCH_RESULTS' | translate }}
  </div>
</div>
<div class="z" [class]="data.count > 5 ? 'showMoreIcon' : 'hideMoreIcon'">
  <nb-icon nbSuffix icon="{{ scrollIcon }}" pack="eva" class="icon-navigate"></nb-icon>
</div>
